import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import TawkChatButton from './components/TawkChatButton';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/Home';
import AboutPage from './pages/About';
import WhyUsPage from './pages/WhyUs';
import ServicesPage from './pages/Services';
import CriminalPage from './pages/Criminal';
import LocationPage from './pages/Location';
import ContactPage from './pages/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/why-us" element={<WhyUsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/criminal" element={<CriminalPage />} />
            <Route path="/location" element={<LocationPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <TawkChatButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
